module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-thoracic1.ec341423.png";